import {useState} from "react";
import {Input} from "antd";
import styles from "./optionalMessage.module.scss";

interface OptionalMessageProps {
    onChange?: (value: string) => void,
    value?: string;
}

export default function OrderOptionalMessage(props: OptionalMessageProps) {
    const [optionalMessage, setOptionalMessage] = useState<string | null>(props.value ?? null);

    const onChange = (value: string) => {
        setOptionalMessage(value);
        props.onChange?.(value);
    }

    return <div>
        <Input.TextArea
            placeholder={"Wpisz wiadomość..."}
            autoSize={{minRows: 3, maxRows: 10}}
            value={optionalMessage ?? ""}
            onChange={e => onChange(e.target.value)}
        />
        <div
            className={styles.messageLength}
            style={{color: optionalMessage?.length === 250 ? "#F65800" : (optionalMessage?.length ?? 0) > 250 ? "red" : "unset"}}
        >
            {(optionalMessage?.length ?? 0)} / 250
        </div>
    </div>
}